module.exports = __webpack_public_path__ + "static/media/managers-guide3.514797e8.png";